export const getRandomElements = (arr, num) => {
  if (Array.isArray(arr)) {
    return arr?.slice(0, num);
  }
};
